import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const Footer = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    api.get("/categories").then((r) => setCategories(r.data.slice(0, 6))).catch(() => {});
  }, []);

  return (
    <footer className="bg-slate-950 text-slate-400 border-t border-slate-800 mt-auto" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid gap-10 md:grid-cols-4">
        <div>
          <p className="font-display font-extrabold text-white text-xl tracking-tight">
            sols<span className="text-amber-400">diarias</span>360
          </p>
          <p className="text-sm mt-3 leading-relaxed">
            Soluciones inteligentes para cada día. Seleccionamos productos prácticos que resuelven
            problemas cotidianos y enlazamos a Amazon España para completar la compra.
          </p>
        </div>

        <div>
          <p className="text-white font-semibold text-sm mb-3 uppercase tracking-wider">Categorías</p>
          <ul className="space-y-2 text-sm">
            {categories.map((c) => (
              <li key={c.slug}>
                <Link to={`/categoria/${c.slug}`} data-testid={`footer-category-${c.slug}`} className="hover:text-amber-400 transition-colors">
                  {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="text-white font-semibold text-sm mb-3 uppercase tracking-wider">La tienda</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/guias" data-testid="footer-guides-link" className="hover:text-amber-400 transition-colors">Guías y consejos</Link></li>
            <li><Link to="/sobre-nosotros" data-testid="footer-about-link" className="hover:text-amber-400 transition-colors">Sobre nosotros</Link></li>
            <li><Link to="/contacto" data-testid="footer-contact-link" className="hover:text-amber-400 transition-colors">Contacto</Link></li>
            <li><Link to="/admin" data-testid="footer-admin-link" className="hover:text-amber-400 transition-colors">Acceso administrador</Link></li>
          </ul>
        </div>

        <div>
          <p className="text-white font-semibold text-sm mb-3 uppercase tracking-wider">Legal</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/legal/aviso-legal" data-testid="footer-legal-notice" className="hover:text-amber-400 transition-colors">Aviso legal</Link></li>
            <li><Link to="/legal/privacidad" data-testid="footer-privacy-link" className="hover:text-amber-400 transition-colors">Política de privacidad</Link></li>
            <li><Link to="/legal/cookies" data-testid="footer-cookies-link" className="hover:text-amber-400 transition-colors">Política de cookies</Link></li>
            <li><Link to="/legal/afiliacion" data-testid="footer-affiliate-link" className="hover:text-amber-400 transition-colors">Declaración de afiliación</Link></li>
            <li>
              <button
                onClick={() => window.dispatchEvent(new Event("s360-open-cookies"))}
                data-testid="footer-cookie-preferences"
                className="hover:text-amber-400 transition-colors"
              >
                Preferencias de cookies
              </button>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 text-xs leading-relaxed space-y-2">
          <p data-testid="affiliate-disclosure">
            Como asociado de Amazon, solsdiarias360 obtiene ingresos por las compras adscritas que
            cumplen los requisitos aplicables. Comprar a través de nuestros enlaces no tiene ningún
            coste adicional para ti.
          </p>
          <p>
            solsdiarias360 es un sitio independiente de recomendaciones y no es la tienda oficial de
            Amazon. Los precios y la disponibilidad de los productos pueden cambiar en Amazon.es;
            el precio aplicable es el mostrado en Amazon en el momento de la compra.
          </p>
          <p className="text-slate-500">© {new Date().getFullYear()} solsdiarias360</p>
        </div>
      </div>
    </footer>
  );
};
